import { render, staticRenderFns } from "./btn-primary2.vue?vue&type=template&id=7ffb23f4&scoped=true&"
import script from "./btn-primary2.vue?vue&type=script&lang=js&"
export * from "./btn-primary2.vue?vue&type=script&lang=js&"
import style0 from "./btn-primary2.vue?vue&type=style&index=0&id=7ffb23f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb23f4",
  null
  
)

export default component.exports